var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuIcon04On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_3567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 38.1666V35.8333H23.0001V27.6666C23.0001 26.0527 23.4862 24.6187 24.4584 23.3645C25.4306 22.1103 26.6945 21.2888 28.2501 20.8999V18.3333H31.7501V20.8999C33.3056 21.2888 34.5695 22.1103 35.5417 23.3645C36.514 24.6187 37.0001 26.0527 37.0001 27.6666V35.8333H39.3334V38.1666H20.6667ZM30.0001 41.6666C29.3584 41.6666 28.8091 41.4381 28.3522 40.9812C27.8952 40.5242 27.6667 39.9749 27.6667 39.3333H32.3334C32.3334 39.9749 32.1049 40.5242 31.648 40.9812C31.1911 41.4381 30.6417 41.6666 30.0001 41.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_3567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuIcon04On);
export default __webpack_public_path__ + "static/media/leftmenu_icon04_on.9c893e684965122cc0a9669983649836.svg";
export { ForwardRef as ReactComponent };